export class PlanoSituacao {
    idSituacao: number;
    nmSituacao: string;
}